<template>
  <div class="billManagement">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/HZinventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>货物</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="inpBox">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px">
        <el-form-item label="捆包编号:">
          <el-input type="textarea" v-model="cargoBarcodes" style="width:175px;" size="mini" placeholder="可支持多个"></el-input>
        </el-form-item>
        <el-form-item label="盘库状态:">
          <el-select v-model="formData.inventoryDetailStatus" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in inventoryDetailStatusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库时间:">
          <el-date-picker v-model="formData.inventoryTimeStart" size="mini" type="datetime" placeholder="请选择盘库时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>-
          <el-date-picker v-model="formData.inventoryTimeEnd" size="mini" placeholder="请选择盘库时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="仓位:">
          <el-select v-model="cangKuName" size="mini" style="width: 150px" @change="changeXiugaiKW(cangKuName)" placeholder="请选择">
            <el-option v-for="item in addKuwei" :label="item.warehouseName" :key="item.warehouseId" :value="item.warehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区位:">
          <el-select v-model="quWeiName" size="mini" style="width: 150px" @change="changeXiugaiQW(quWeiName)" placeholder="请选择">
            <el-option v-for="item in addQ" :label="item.locationName" :key="item.locationId" :value="item.locationId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货位:">
          <el-select v-model="huoWeiName" size="mini" style="width: 150px" @change="changeXiugaiHW(huoWeiName)" placeholder="请选择">
            <el-option v-for="item in addH" :label="item.binName" :key="item.binId" :value="item.binId"></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="仓位:">
          <el-input type="text" v-model="formData.warehouseName" style="width:175px;vertical-align:top;" size="mini" placeholder="请输入仓位" ></el-input>
        </el-form-item>
         <el-form-item label="区位:">
          <el-input type="text" v-model="formData.locationName" style="width:175px;vertical-align:top;" size="mini" placeholder="请输入区位" ></el-input>
        </el-form-item>
         <el-form-item label="货位:">
          <el-input type="text" v-model="formData.binName" style="width:175px;vertical-align:top;" size="mini" placeholder="请输入货位" ></el-input>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: '63vh' }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryDetailStatus" label="盘库状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.inventoryDetailStatus==0">未盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==1">已盘</span>
            <span v-else-if="scope.row.inventoryDetailStatus==2">盘库新增</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="库位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryPerson" label="盘库人" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTime" label="盘库时间" align="center" width="200"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template v-slot="scope">
            <el-button type="text" @click="tupian(scope.row)">图片</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
        <div>
          <div class="img_box" v-for="(item,index) in imgData" :key="index">
            <el-image :src="item.url" :preview-src-list="imgList" class="tupian"></el-image>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getImgShow
} from '@/api/wms-stock'
import {
  getInventoryGoodsList
} from '@/api/soc-stock'
export default {
  data () {
    return {
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      formData: {
        cargoBarcodes: '',
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: ''
      },
      cargoBarcodes: '',
      addKuwei: [],
      addQ: [],
      addH: [],
      cangKuName: '', // 仓库名
      quWeiName: '', // 区位名
      huoWeiName: '', // 货位名
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      inventoryDetailStatusData: [
        {
          id: '1',
          name: '已盘'
        },
        {
          id: '0',
          name: '未盘'
        },
        {
          id: '2',
          name: '盘库新增'
        }
      ],
      total: 0,
      addMarkLookBox: false,
      imgData: [],
      inventoryMasterId: '',
      imgList: []
    }
  },
  created () {
    this.chaxun()
  },
  methods: {
    getInventoryGoodsList () {
      this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
      getInventoryGoodsList({
        inventoryMasterId: this.$route.query.inventoryMasterId,
        ...this.formData,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getInventoryGoodsList()
    },
    chongzhi () {
      this.formData = {
        cargoBarcodes: '',
        inventoryDetailStatus: '',
        inventoryTimeStart: '',
        inventoryTimeEnd: ''
      }
      this.cargoBarcodes = ''
      this.kuweiId = '' // 仓库名（下拉框key）
      this.QId = '' // 区位名（下拉框key）
      this.HId = '' // 货位名（下拉框key）
      this.cangKuName = '' // 仓库名
      this.quWeiName = '' // 区位名
      this.huoWeiName = ''
      this.kuweiName = ''
      this.QName = ''
      this.HName = ''
      this.chaxun()
    },
    tupian (row) {
      this.addMarkLookBox = true
      getImgShow({
        businessId: row.inventoryDetailId,
        businessType: 'inventory_picture'
      }).then(res => {
        console.log(res)
        this.imgData = res
        this.imgList = res.map(item => item.url)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--区位
    zidianQuweiS () {
      zidianQuwei({
        warehouseId: this.kuweiIds || this.xuanzhongArr.warehouseId || this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 字典--货位
    zidianHuoweiS () {
      // console.log(this.QIds ,this.xuanzhongArr.locationId ,this.QId)
      zidianHuowei({
        locationid: this.QIds || this.xuanzhongArr.locationId || this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取库位下拉框其他值
    changeXiugaiKW: function (valueS) {
      let choosenKuwei = this.addKuwei.filter(
        (item) => item.warehouseId === valueS
      )[0]
      this.quWeiName = ''
      this.huoWeiName = ''
      this.QId = ''
      this.HId = ''
      this.kuweiId = choosenKuwei.warehouseId
      this.kuweiName = choosenKuwei.warehouseName
      // this.zidianQuweiS()
      zidianQuwei({
        warehouseId: this.kuweiId
      })
        .then((res) => {
          this.addQ = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取区位下拉框其他值
    changeXiugaiQW: function (valueS) {
      let choosenQ = this.addQ.filter((item) => item.locationId === valueS)[0]
      this.QId = choosenQ.locationId
      this.QName = choosenQ.locationName
      this.huoWeiName = ''
      this.HId = ''
      zidianHuowei({
        locationid: this.QId
      })
        .then((res) => {
          this.addH = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取货位下拉框其他值
    changeXiugaiHW: function (valueS) {
      let choosenH = this.addH.filter((item) => item.binId === valueS)[0]
      this.HId = choosenH.binId
      this.HName = choosenH.binName
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  margin-top: 15px;
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.addMarkBox {
  .noImg {
    text-align: center;
  }
}
.img_box {
  width: 150px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width: 100%;
    height: 100%;
  }
}
</style>
